import React from 'react';
import { ListLayout } from '../../../common/components/layout';
import UserList from './list/userList';

const users = () => {
  return <ListLayout list={<UserList />} />;
};

export default users;
